<template>
  <section v-if="guidleId || isEditing" :id class="container">
    <div v-if="isEditing">Placeholder for the Guidle widget.</div>
    <ClientOnly v-else-if="guidleId">
      <GuidleIframe :guidle-id="guidleId" />
    </ClientOnly>
  </section>
</template>

<script lang="ts" setup>
defineProps<{
  guidleId?: string
}>()

const { isEditing, index, siblings } = defineBlokkli({
  bundle: 'guidle',
  globalOptions: ['bkHiddenGlobally', 'publicationChannels'],
})

const id = useParagraphAnchorId(index, siblings)
</script>
